import { FlexColumn, MaterialIcon } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { Filter } from 'baseui/table';
import { memo } from 'react';
import { useStyles } from '../../../hooks/useStyles';
import { StyledTooltip } from '../../ui/StyledTooltip';
import { useFleetServices } from '../hooks/useFleetServices';
import FleetMaintenanceRuleSelect from '../shared/FleetMaintenanceRuleSelect';
import FleetServiceStatusSelect from '../shared/FleetServiceStatusSelect';

export function FleetServiceFilters() {
  const { theme, css, overrides } = useStyles();
  const { filters, hasActiveFilters, resetFilters, onChangeFilter } = useFleetServices();

  return (
    <>
      <Filter
        active={hasActiveFilters}
        overrides={overrides.filtersOverrides(resetFilters)}
      >
        <FlexColumn
          classNames={css({
            paddingTop: theme.sizing.scale500,
            paddingBottom: theme.sizing.scale500,
          })}
          gap={theme.sizing.scale200}
        >
          <FleetMaintenanceRuleSelect
            selectedMaintenanceRuleId={filters.configurationId}
            onChangeMaintenanceRuleId={(maintenanceRuleId) => onChangeFilter('configurationId', maintenanceRuleId)}
            showEmptyOption
            isFilter
            inline
          />
          <FleetServiceStatusSelect
            selectedId={filters.status}
            onChangeId={(fleetServiceStatus) => onChangeFilter('status', fleetServiceStatus)}
            showEmptyOption
            isFilter
            inline
          />
        </FlexColumn>
      </Filter>
      <StyledTooltip
        content="Limpiar filtros"
        showArrow={false}
      >
        <Button
          size="mini"
          shape="round"
          onClick={resetFilters}
          kind="tertiary"
          disabled={!hasActiveFilters}
        >
          <MaterialIcon
            name="clear"
            size="mini"
            color={!hasActiveFilters ? theme.colors.contentStateDisabled : undefined}
          />
        </Button>
      </StyledTooltip>
    </>
  );
}

export default memo(FleetServiceFilters);
